"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//拖拽组件
var _default = exports.default = {
  name: 'componenmanagement',
  props: ['datas'],
  components: {
    vuedraggable: _vuedraggable.default
  },
  data: function data() {
    return {
      data: this.datas,
      dragOptions: {
        animation: 200,
        // class是 delDragitem 禁止拖拽
        filter: '.delDragitem'
      }
    };
  },
  methods: {
    /* 删除组件 */onConfirms: function onConfirms(res) {
      this.data.splice(res, 1);
    },
    /**
     * 拖拽移动拦截：
     * 悬浮按钮（type '1-10'）固定在最末尾，
     * 任何会让它失去末尾位置（被插入到它后面）的操作都取消。
     */
    onMove: function onMove(evt) {
      var related = evt.relatedContext && evt.relatedContext.element;
      if (related && related.type === '1-10' && evt.willInsertAfter) {
        return false;
      }
      return true;
    }
  },
  watch: {
    datas: function datas(newVal) {
      this.data = newVal;
    },
    data: function data(newVal) {
      this.$emit('componenmanagement', newVal);
    }
  },
  computed: {}
};